import React, {Component} from 'react';

export default class MaterialInput extends Component {
    render(){
        return (
            <div className="materialinput">
                <div className={"group " + this.props.grpclassname}>      
                <input type="text" required {...this.props}/>
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>{this.props.label}</label>
            </div></div>
        )
    }
}

 


// WEBPACK FOOTER //
// ./src/components/FormInputs/MaterialInput.jsx